import { get, post, put, del } from "../common/apiClient";

const PATH = "/user";
const PATH_ADMIN = "/admin";

/**
 * Lấy thông tin user hiện tại (bao gồm role).
 * Dùng cho AdminRoute để check quyền.
 */
export async function fetchCurrentUser() {
    return await get(`${PATH}/user-info`);
}

/**
 * Danh sách user có phân trang + search + filter.
 *
 * @param {Object} opts
 * @param {number} opts.page
 * @param {number} opts.limit
 * @param {string} opts.q           - search theo email/username/school/_id
 * @param {string|number} opts.role - 0=user, 1=admin, 2=ctv (optional)
 */
export async function listUsers({
    page = 1,
    limit = 12,
    q = "",
    role = "",
    isLocked = "",
    sortBy = "createdAt",
    sortOrder = "desc",
} = {}) {
    const params = new URLSearchParams();
    params.append("page", String(page));
    params.append("limit", String(limit));
    if (q) params.append("q", q);
    if (role !== "" && role !== null && role !== undefined) {
        params.append("role", String(role));
    }
    if (isLocked !== "" && isLocked !== null && isLocked !== undefined) {
        params.append("isLocked", String(isLocked));
    }
    if (sortBy) params.append("sortBy", sortBy);
    if (sortOrder) params.append("sortOrder", sortOrder);

    return await get(`${PATH}?${params.toString()}`);
}

/**
 * Tạo user mới.
 * Backend: POST /user — payload KHÔNG có _id
 */
export async function createUser(payload) {
    return await post(PATH, payload);
}

/**
 * Cập nhật user.
 * Backend: POST /user — payload CÓ _id (cùng endpoint, dùng _id để phân biệt)
 */
export async function updateUser(payload) {
    return await post(PATH, payload);
}

/**
 * Xoá user theo ObjectId.
 */
export async function deleteUserById(userId) {
    return await del(`${PATH}/${encodeURIComponent(userId)}`);
}

/**
 * Role constants — khớp với CONSTANT bên backend.
 */
export const ROLE = {
    USER: 0,
    ADMIN: 1,
    CTV: 2,
};

export const ROLE_LABEL = {
    0: "User",
    1: "Admin",
    2: "CTV",
};

export const ROLE_OPTIONS = [
    { value: 0, label: "User" },
    { value: 1, label: "Admin" },
    { value: 2, label: "CTV" },
];

export function isAdminRole(role) {
    return role === ROLE.ADMIN;
}

export function isAdminOrCtv(role) {
    return role === ROLE.ADMIN || role === ROLE.CTV;
}

/* ─────────────────────────────────────────────
   Admin-only endpoints (role=1 required)
   ───────────────────────────────────────────── */

/**
 * Đọc giá trị MAX_DEVICES hiện tại.
 */
export async function getMaxDevicesConfig() {
    return await get(`${PATH_ADMIN}/system/max-devices`);
}

/**
 * Cập nhật giá trị MAX_DEVICES.
 * @param {number} value
 */
export async function updateMaxDevicesConfig(value) {
    return await put(`${PATH_ADMIN}/system/max-devices`, { value });
}

/**
 * Mở khoá một user đang bị lock + xóa cache Redis liên quan.
 * @param {string} userId
 */
export async function unlockUser(userId) {
    return await post(
        `${PATH_ADMIN}/users/${encodeURIComponent(userId)}/unlock`,
    );
}

/**
 * Khoá một user đang hoạt động + ghi cache Redis + deactivate sessions.
 * @param {string} userId
 * @param {string} [reason]
 */
export async function lockUser(userId, reason = "") {
    return await post(
        `${PATH_ADMIN}/users/${encodeURIComponent(userId)}/lock`,
        { reason },
    );
}
